export default __webpack_public_path__ + "static/media/master_logo.b720e3b5.svg";